import { Component, OnInit } from "@angular/core";
import { Workflow } from "src/app/parametrage/core/model/workflow";
import { DatePipe } from "@angular/common";
import { WorkflowService } from "src/app/parametrage/core/service/workflow.service";
import { ReportingService } from "../core/service/reporting.service";

@Component({
  selector: "app-extraction",
  templateUrl: "./extraction.component.html",
  styleUrls: ["./extraction.component.scss"]
})
export class ExtractionComponent implements OnInit {
  debut: any = null;
  fin: any = null;
  workflowCategorie: String;

  workflows: Workflow[];

  constructor(
    private datePipe: DatePipe,
    private _workflowService: WorkflowService,
    private _reportingService: ReportingService
  ) {}

  ngOnInit() {}

  exportDossiersACorriger() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersACorriger(deb, fn, this.workflowCategorie)
      .subscribe(blob => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "dossier-a-corriger-" + deb + ".xlsx");
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersAll() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersAll(deb, fn, this.workflowCategorie)
      .subscribe(blob => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute("download", "dossier-a-all-" + deb + ".xlsx");
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersAParGestionnaireInit() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersParGestionnaire(deb, fn, this.workflowCategorie, "_")
      .subscribe(blob => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "qhantite-dossier-initie-" + deb + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersAParGestionnaireEncours() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersParGestionnaire(deb, fn, this.workflowCategorie, "ENCOURS")
      .subscribe(blob => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "qhantite-dossier-initie-" + deb + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersAParGestionnaireMisEnPlace() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersParGestionnaire(
        deb,
        fn,
        this.workflowCategorie,
        "MISEENPLACE"
      )
      .subscribe(blob => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "qhantite-dossier-initie-" + deb + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersAParGestionnaireAbandonne() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersParGestionnaire(
        deb,
        fn,
        this.workflowCategorie,
        "ABANDONNE"
      )
      .subscribe(blob => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "qhantite-dossier-initie-" + deb + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }

  exportDossiersAParGestionnaireEnAttentteCorrection() {
    let deb = this.datePipe.transform(this.debut, "yyyy-MM-ddTHH:mm:ss") || "";
    let fn = this.datePipe.transform(this.fin, "yyyy-MM-ddTHH:mm:ss") || "";

    this._reportingService
      .exportDossiersParGestionnaire(
        deb,
        fn,
        this.workflowCategorie,
        "ENATTENTECOMPLEMENT"
      )
      .subscribe(blob => {
        let fileUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = fileUrl;
        link.setAttribute(
          "download",
          "qhantite-dossier-initie-" + deb + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      });
  }
}
